import Auth from "./Auth"

const Header = () => {
  return (
    <header className="w-full flex justify-between items-center flex-wrap px-2 py-4">
      <h1 className="nes-text is-primary uppercase text-3xl">link ocean</h1>

      <Auth />
    </header>
  )
}

export default Header